module.exports = __webpack_public_path__ + "img/coconut-cocktail.d66e2fa6.svg";